import Product from "./Product";
import compose from "recompose/compose";
import mapProps from "recompose/mapProps";
import { withModel } from "../../../data-providers/model";
import { localiseUrl } from "src/common/utils/format-localised-url";
import { replaceTextWithValues } from "src/common/utils/text-replace";

const getColorByBgColor = (bgColor) => {
  if (!bgColor) {
    return "";
  }
  return parseInt(bgColor.replace("#", ""), 16) > 0xffffff / 2
    ? "#000"
    : "#fff";
};

const enhance = compose(
  withModel,
  mapProps((props) => {
    const minAge = props.minimumAge;
    const maxAge = props.maximumAge;

    return {
      link: localiseUrl(
        props.model.countryModel,
        `/personalized-products/${props.productSlug}`
      ),
      showArrow: props.showArrow,
      showBadge: props.showBadge,
      showPrice: props.showPrice,
      showDescription: props.showDescription,
      badgeContent: props.badgeContent || props.productBadgeContent,
      badgeContentColor: getColorByBgColor(props.productBadgeBackgroundColor),
      badgeBackgroundColor: props.productBadgeBackgroundColor,
      image: props.image,
      imageBackgroundColor: props.backgroundColor,
      title: props.title,
      description: [
        {
          type: "paragraph",
          text: props.description,
          spans: [],
        },
      ],
      age: replaceTextWithValues(props.ageRangeLabel, { minAge, maxAge }),
      productPriceLabel: props.productPriceLabel,
      price: props.price,
      savings: props.savings,
      productTags: props.productTags,
      showProductTag: props.showProductTag,
    };
  })
);

export default enhance(Product);
